// extracted by mini-css-extract-plugin
export default {"tableContainer":"styles_tableContainer__AYGHF","spacerCell":"styles_spacerCell__dRSTR"};